var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 2a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 1-14.996.243L1.5 9.5l.003-.21A7.5 7.5 0 0 1 9 2Zm.008 9.75-.096.005a.75.75 0 0 0 0 1.49L9 13.25l.095-.005a.75.75 0 0 0 0-1.49l-.088-.005ZM9 5.75a.75.75 0 0 0-.745.662L8.25 6.5v3l.005.088a.75.75 0 0 0 1.49 0L9.75 9.5v-3l-.005-.088A.75.75 0 0 0 9 5.75Z",
  fill: "#232323"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 2a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 1-14.996.243L1.5 9.5l.003-.21A7.5 7.5 0 0 1 9 2Zm.008 9.75-.096.005a.75.75 0 0 0 0 1.49L9 13.25l.095-.005a.75.75 0 0 0 0-1.49l-.088-.005ZM9 5.75a.75.75 0 0 0-.745.662L8.25 6.5v3l.005.088a.75.75 0 0 0 1.49 0L9.75 9.5v-3l-.005-.088A.75.75 0 0 0 9 5.75Z",
  fill: "#547D84"
})));
export default SvgAlertCircleFilled;